import {
	DepositQuestionsAuditStatus,
	HasNonMainlandBankCardEnum,
	IdentityTypes,
	MasterAccountOpenStatus,
	OCRStatus,
	OpenAccountRejectInitialReviewReasonTypes,
} from "./enums";

export enum SurveyType {
	ACCOUNT_OPENING = 1, // 开户问题（上传证件+基本信息问题）
	DEPOSIT = 2, // 入金问题 （提交入金单后的问题）
	SEARCH_RESULTS_FEEDBACK = 5, // 搜索结果反馈问卷
	WITHDRAWAL_FEEDBACK = 7, // 出金反馈问卷
	APP_UPGRADE = 8, // APP升级问卷
	IPO_MIXUE_GROUP = 9, // IPO 蜜雪冰城问卷
	IDEAS = 10, // 意见反馈问卷
	coupon_Queen = 11, // 优惠券女王问卷
	ai_registration = 12, // AI报名
	improve_experience = 13, // 改善体验问卷
	IPO_CTAL = 14, // IPO 宁德时代
	IPO_MIXUE_HENG = 15, // IPO 恒瑞医药
}

export enum AddressProofType {
	UNKNOWN = 0, //未知
	BANK_STATEMENT, //银行结单
	BROKERAGE_STATEMENT, //券商结单
	HOMEOWNER_INSURANCE_POLICY_BILL, //房主保险账单
	HOMEOWNER_INSURANCE_POLICY_DOCUMENT, //房主保险单
	RENTER_INSURANCE_POLICY_BILL, //租户保险账单
	RENTER_INSURANCE_POLICY_DOCUMENT, // 租户保险单
	SECURITY_SYSTEM_BILL, //家庭安全系统账单
	GOVERNMENT_ISSUED_LETTERS, // 政府签发的信件
	UTILITY_BILL, //物业水电费账单
	CURRENT_LEASE, //租房合同
	EVIDENCE_OF_OWNERSHIP_OF_PROPERTY, //产权证明
	DRIVER_LICENSE, //驾照
	OTHER_DOCUMENT, //其他
}

export enum TINRadiosType {
	UNKNOWN = 0, //未知
	TIN_NOT_DISCLOSED, // 根据所填国家的法律规定，我不能披露我的纳税识别号（TIN）
	TIN_NOT_REQUIRED, // 在所填国家，没有法律规定我必须获取纳税识别号（TIN）
	TIN_NOT_ISSUED, // 所填国家不向纳税人签发纳税识别号（TIN）
}

export const TINOptions = [
	{
		value: TINRadiosType.TIN_NOT_DISCLOSED,
		i18nKey: "TIN_NOT_DISCLOSED",
	},
	{
		value: TINRadiosType.TIN_NOT_REQUIRED,
		i18nKey: "TIN_NOT_REQUIRED",
	},
	{
		value: TINRadiosType.TIN_NOT_ISSUED,
		i18nKey: "TIN_NOT_ISSUED",
	},
];
export interface CountryListRequest {
	language?: string;
	smsAvailable?: boolean;
	sticky?: boolean;
}

export interface GeoCountry {
	name: string;
	phoneCode: string;
	currency: string;
	currencyName: string;
	currencySymbol: string;
	nativeName: string;
	emoji: string;
	native?: string;
	writeOnly?: true;
	acronym: string;
}

export interface GeoState {
	name: string;
	countryCode: string;
	acronym: string;
}

export interface Question {
	id: number;
	questionType: SurveyType;
	field: string;
	uiSchema: string;
	avaliable: boolean;
	createTime: string;
	updateTime: string;
}

export interface QuestionsResponse {
	totalElements: number;
	questions: Question[];
}

export interface Answer {
	answer: string;
	field: string;
	questionId: number;
	userId: number;
}
export interface TaxpayersResponse {
	accountTaxPayers: Taxpayer[];
	totalElements: number;
}

export interface Taxpayer {
	createTime?: number;
	explanation?: number;
	hasTaxPayerNumber: boolean;
	id: number;
	taxPayerNumber: string;
	taxResidence: string;
	updateTime: number;
	userId: number;
}

export interface AnswerQuestionModel {
	answer: string;
	questionId: string;
}

export interface UploadAddressProofsRequest {
	images: string[];
	/**
	 * BANK_STATEMENT
	 */
	proofType: AddressProofType;
}

export interface UpsertTaxpayerRequest {
	explanation: number;
	hasTaxPayerNumber: boolean;
	taxPayerNumber: string;
	taxResidence: string;
}

export interface ORCRequest {
	identityFirstImage: string;
	identityType: IdentityTypes;
	identitySecondImage?: string;
}

// uiSchema
export interface SurveyQuestionUISchema {
	type: SurveyQuestionTypes;
	title: string;
	i18nKey: string;
	props: SurveyQuestionProps;
	validate?: SurveyQuestionValidate[]; // 用不到
	options: SurveyQuestionOption[];
}

export enum SurveyQuestionTypes {
	INPUT = "input",
	RADIO = "radio",
	CHECKBOX = "checkbox",
	SELECT = "select",
	DATE_PICKER = "datePicker",
}

export interface SurveyQuestionProps {
	required?: boolean;
	placeholder?: string;
	placeI18nKey?: string;
	multiple?: boolean;
	type?: "number" | "text";
}

export interface SurveyQuestionValidate {
	message: string;
	i18nKey: string;
	required?: boolean;
}

export interface SurveyQuestionOption {
	value: string;
	label: string;
	i18nKey: string;
	disabled: boolean;
}

export interface AccountStatus {
	hasPhone: boolean;
	hasEmail: boolean;
}

export interface OCRResponse {
	identityFirstImage: string;
	identitySecondImage: string;
	identityType: IdentityTypes;
	identityNo: string;
	ocrResult: OCRStatus;
	address: string;
	fullNameEn: string;
	fullNameLocal: string;
	gender: number;
	givenNameEn: string;
	givenNameLocal: string;
	lastNameEn: string;
	lastNameLocal: string;
	middleNameEn: string;
	middleNameLocal: string;
	regionEn: string;
	regionLocal: string;
}

export interface MasterAccountInfo {
	masterAccountId: string;
	masterAccountStatus: string;
	accountOpeningQuestionsAnswered: boolean; //开户问题已回答[true]
	depositQuestionsAnswered: boolean; //存款问题已回答[true]
	depositStatus: number;
	ocrStatus: OCRStatus;
	masterAccountName: string;
	addressProofStatus: number; // 地址证明提交状态 1
	rejectReason: OpenAccountRejectInitialReviewReasonTypes;
	depositQuestionsAuditStatus: DepositQuestionsAuditStatus;
	masterAccountOpenStatus: MasterAccountOpenStatus;
	hasNonMainlandBankCard?: HasNonMainlandBankCardEnum;
}
